import PocketBase from 'https://esm.sh/pocketbase';

// Acceso seguro a variables de entorno con optional chaining para evitar errores si el objeto env es undefined
const PB_URL = (import.meta as any).env?.VITE_POCKETBASE_URL || 'https://pocketbase.cr-safe.com';

export const pb = new PocketBase(PB_URL);